import { ReactNode } from "react";
import Navbar from "../components/Navbar";
import LiveChat from "../components/LiveChat";

export default function InstructorLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-grayBG pb-20">
      <Navbar />
      <div className="px-4 pt-4 pb-16">{children}</div>
      <LiveChat />
    </div>
  );
}
